import React from "react";

import MdAlert from "react-ionicons/lib/MdAlert";

import "./Error.scss";

const Error = ({ error, left }) => {
  return error && error.message ? (
    <div
      className={`bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded relative my-4 ${
        left ? "self-start" : "mx-auto max-w-md"
      }`}
      role="alert"
    >
      <strong className="font-light pr-4 text-sm mr-2">{error.message}</strong>
      <span className="absolute top-0 bottom-0 right-0 px-2 py-2">
        <svg
          className="fill-current h-6 w-6 text-red-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path
            className="heroicon-ui"
            d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 9a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
          />
        </svg>
      </span>
    </div>
  ) : (
    <div></div>
  );
};

export default Error;
